module.exports = __webpack_public_path__ + "img/four.be5030ca.webp";